// The same five entities as Highcharts' `SVGRenderer.escapes`, which its text renderer decodes when a string contains
// no markup. Using any other form (e.g. `&#x27;`) would render literally on that path.
const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

const HTML_SPECIAL_CHARACTERS = /[&<>"']/g;

export type EscapableValue = string | number | boolean | null | undefined;

/**
 * Makes a user- or data-derived value safe to place in any Highcharts text option or formatter output, so it renders
 * as literal text instead of being parsed as markup.
 */
export function escapeHtml(value: EscapableValue): string {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).replace(HTML_SPECIAL_CHARACTERS, (character) => HTML_ESCAPES[character]);
}

/**
 * For Highcharts option text where a missing value is meaningful: an `undefined` axis title falls back to the
 * Highcharts default, whereas `''` would silently blank it.
 */
export function escapeOptionalHtml(value: string | undefined): string | undefined {
  if (value === undefined) {
    return value;
  }
  return escapeHtml(value);
}
